<template>
  <div id="login">
    <!-- TITLE//S-->
    <div class="page-header">
      <h3>{{ $t("resetPassword.title") }}</h3>
    </div>
    <!-- TITLE//E-->
    <div class="login-info-text">
      <p class="help-block text-darkgray">
        {{ $t("resetPasswordPage.description") }}
      </p>
    </div>
    <!-- LOGIN FORM//S -->
    <div class="well login-wrap">
      <vs-input
        :label="$t('resetPasswordPage.id')"
        :placeholder="$t('resetPasswordPage.enterEmail')"
        class="input-block input-custom"
        v-model="userid"
      ></vs-input>
      <!-- RECAPTCHA//S -->
      <div class="recaptcha">
        <div
          class="g-recaptcha"
          :data-sitekey="rcapt_sig_key"
          ref="recaptcha"
        ></div>
      </div>
      <!-- RECAPTCHA//E -->
      <div class="button-wrap">
        <vs-button
          color="dark"
          class="btn-block custom login-gray"
          type="filled"
          @click="$router.push({ name: 'Login' })"
          >{{ $t("login.login") }}</vs-button
        >
        <vs-button
          color="danger"
          class="btn-block custom send-email"
          type="filled"
          @click="sendPasswordEmail"
          >{{ $t("resetPasswordPage.resetEmail") }}</vs-button
        >
      </div>
    </div>
    <!-- LOGIN FORM//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
export default {
  created() {
    this.$store.dispatch("logOut");
    if (this.$route.params.email) {
      this.userid = this.$route.params.email;
    }
  },
  data() {
    return {
      userid: "",
      rcapt_sig_key: this.$isDevServer
        ? "6LeiYOAUAAAAADdnn73t4Qwg6jZNhRAA-JGRpzXS"
        : "6LfOpkcUAAAAAG4JscMvBbFfTpRHbPaUJQcE4WYE",
      rcapt_id: 0,
    };
  },
  mounted() {
    if (window.grecaptcha) {
      this.rcapt_id = grecaptcha.render(this.$refs.recaptcha, {
        sitekey: this.rcapt_sig_key,
      });
    } else {
      this.$alert("Recaptcha 초기화에 실패했습니다.");
    }
  },
  methods: {
    sendPasswordEmail() {
      var emailRule = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRule.test(this.userid)) {
        this.joinFailNoti(this.$t("notice.content.accountValid"));
        return false;
      }
      const g_recaptcha_response = grecaptcha.getResponse(this.rcapt_id);
      Api.User.resetPassword({ email: this.userid, g_recaptcha_response })
        .then((_res) => {
          //비밀번호 메일이 발송되었습니다. (메인으로 이동))
          this.$vs.notify({
            title: this.$t("resetPasswordPage.sendPopup.title"),
            text: this.$t("resetPasswordPage.sendPopup.sendPassword"),
            type: "warning",
            position: "top-left",
          });
          this.$router.push({ name: "Main" });
        })
        .catch((e) => {
          // this.$message({message: e.msg});
          this.$vs.notify({
            title: "안내",
            text: e.msg,
            position: "top-right",
            color: "danger",
          });
        });
    },
    joinFailNoti(text, title = this.$t("resetPassword.title")) {
      this.$vs.notify({
        title,
        text,
        position: "top-right",
        color: "danger",
      });
    },
  },
};
</script>
